import api from './api';

export async function checkout(packageId, creatorCode) {
  const params = creatorCode ? `?creatorCode=${encodeURIComponent(creatorCode)}` : '';
  const response = await api.get(`/checkout/package/${packageId}${params}`);
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data;
}

export async function getAllDonationStoreItems() {
  const response = await api.get('/getDonationItems');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data;
}

export async function getDonationStoreItem(id) {
  const response = await api.get(`/getDonationItem/${id}`);
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data;
}

export async function updateSetting(key, value) {
  const response = await api.post('/updateSetting', { key, value });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function getDownloadLinks() {
  const response = await api.get('/getDownloadLinks');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function getNobilityReset() {
  const response = await api.get('/getNobilityReset');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}
